//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Object.js";
import "../Drawings/Drawings.DraftingView.js";
let d=[[],[],[["General","Drawings.GeneralViewStyle",0],["BaseView","Drawings.BaseViewStyle",0],["Projected","Drawings.ProjectedViewStyle",0],["InheritPmi","Drawings.InheritPmiViewStyle",0],["Section","Drawings.SectionViewStyle",0],["VirtualIntersections","Drawings.VirtualIntersectionsViewStyle",0],["SmoothEdges","Drawings.SmoothEdgesViewStyle",0],["Perspective","Drawings.PerspectiveViewStyle",0],["Orientation","Drawings.OrientationViewStyle",0],["VisibleLines","Drawings.VisibleLinesViewStyle",0],["Threads","Drawings.ThreadsViewStyle",0],["TraceLines","Drawings.TraceLinesViewStyle",0],["HiddenLines","Drawings.HiddenLinesViewStyle",0],["Shading","Drawings.ShadingViewStyle",0],["FlatPattern","Drawings.FlatPatternViewStyle",0],["ShipbuildingLines","Drawings.ShipbuildingLinesViewStyle",0],["ShipDraftingViewLines","Drawings.ShipDraftingViewLinesViewStyle",0],["ShipGeneralArrangementViewLines","Drawings.ShipGeneralArrangementViewLinesViewStyle",0]]];
SPLM.Drawings.ViewStyle = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.ViewStyle";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;